import script from "./CartVisit.vue?vue&type=script&setup=true&lang=js"
export * from "./CartVisit.vue?vue&type=script&setup=true&lang=js"

import "./CartVisit.vue?vue&type=style&index=0&id=5ce8bb84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce8bb84"]])

export default __exports__